import { render, staticRenderFns } from "./internalComments.vue?vue&type=template&id=24f87690&"
import script from "./internalComments.vue?vue&type=script&lang=ts&"
export * from "./internalComments.vue?vue&type=script&lang=ts&"
import style0 from "./internalComments.vue?vue&type=style&index=0&id=24f87690&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports